import { Outlet, type RouteObject } from 'react-router-dom';

import {
  ExamCardProvider,
  ExamEventProvider,
  ExamSessionProvider,
  HeartbeatProvider,
  NewExamFormProvider,
  NewExamProvider,
  ServerTimeProvider,
} from '../../providers';

import BreakRoute from './break';
import CompletedRoute from './completed';
import ExamRoomRoute from './exam-room';
import InstructionRoute from './instruction';
import { ExamEventLayout, ExamLayout } from './layouts';
import PrivacyNoticeRoute from './privacy-notice';
import ProcessingRoute from './processing/Processing';
import ProfileConfirmationRoute from './profile-confirmation';
import QuestionnaireRoute from './questionnaire';
import RootRoute from './root';
import SubmittedRoute from './submitted';
import TermsAndConditionsRoute from './terms-and-conditions/TermsAndConditions';
import { ProtectedExamEventRoute, ProtectedExamRoute } from './utils';

const ExamRoutes: RouteObject[] = [
  {
    element: (
      <ServerTimeProvider>
        <ExamCardProvider>
          <ExamEventProvider>
            <ProtectedExamEventRoute>
              <ExamEventLayout />
            </ProtectedExamEventRoute>
          </ExamEventProvider>
        </ExamCardProvider>
      </ServerTimeProvider>
    ),
    children: [
      RootRoute,
      PrivacyNoticeRoute,
      TermsAndConditionsRoute,
      ProfileConfirmationRoute,
      InstructionRoute,
      QuestionnaireRoute,
      CompletedRoute,
      ProcessingRoute,
      SubmittedRoute,
    ],
  },
  {
    element: (
      <ServerTimeProvider>
        <ExamCardProvider>
          <ExamEventProvider>
            <ProtectedExamEventRoute>
              <Outlet />
            </ProtectedExamEventRoute>
          </ExamEventProvider>
        </ExamCardProvider>
      </ServerTimeProvider>
    ),
    children: [
      {
        element: <ProtectedExamRoute />,
        children: [
          {
            element: (
              <NewExamProvider>
                <ExamSessionProvider>
                  <NewExamFormProvider>
                    <HeartbeatProvider>
                      <ExamLayout>
                        <Outlet />
                      </ExamLayout>
                    </HeartbeatProvider>
                  </NewExamFormProvider>
                </ExamSessionProvider>
              </NewExamProvider>
            ),
            children: [ExamRoomRoute, BreakRoute],
          },
        ],
      },
    ],
  },
];

export default ExamRoutes;
